import { PageHeader } from "@shared/components/PageHeader";
import {
  IntegrationCardGrid,
  IntegrationCardConfig,
} from "@features/ix/shared/IntegrationCardGrid";
import React from "react";
import {
  CreditCard,
  FileText,
  PhoneCall,
  PhoneForwarded,
  Receipt,
  Voicemail,
} from "lucide-react";

// const IVR_INTEGRATION_CARDS: IntegrationCardConfig[] = [
//   {
//     title: "Twilio",
//     description:
//       "Connects SMART360 with Twilio for automated voice responses, SMS notifications, and customer self-service.",
//     status: "not_connected",
//     icon: PhoneCall,
//     comingSoon: true,
//     connectPath: "/integration-hub/ivr-integration/twilio/connect",
//     configurePath: "/integration-hub/ivr-integration/twilio/configure",
//     detailsPath: "/integration-hub/ivr-integration/twilio/details",
//   },
//   {
//     title: "Genesys",
//     description:
//       "Integrates SMART360 with Genesys to orchestrate advanced omnichannel customer experiences.",
//     status: "not_connected",
//     icon: Voicemail,
//     comingSoon: true,
//     connectPath: "/integration-hub/ivr-integration/genesys/connect",
//     configurePath: "/integration-hub/ivr-integration/genesys/configure",
//     detailsPath: "/integration-hub/ivr-integration/genesys/details",
//   },
// ];

const IvrIntegrationLanding = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        title="IVR Integrations"
        subtitle="Connect voice communication providers for customer self-service, outage updates, and call automation."
      />
      <IntegrationCardGrid cards={[]} />
    </div>
  );
};

export default IvrIntegrationLanding;
